export function convertToLocalizationKey(text: string) {
	return text?.toLowerCase()?.split(' ')?.join('_');
}
